import { maskCurrency } from "../../../../common/helpers/mask.helpers"
import { formatCompanyType, formatPartnerType } from "../../../../common/helpers/text.helpers"
export function personalPartnerInfo(partner) {
  return [
    { id: 1, spanSize: 'col-span-1', label: "Nome da empresa", value: partner.companyName },
    { id: 1, spanSize: 'col-span-1', label: "Nome fantasia", value: partner.fantasyName },
    { id: 8, spanSize: 'col-span-1', label: "CNPJ", value: partner.cnpj },
    { id: 5, spanSize: 'col-span-1', label: "Nome do proprietário", value: partner.owner.name },
    { id: 5, spanSize: 'col-span-1', label: "WhatsApp do proprietário", value: partner.owner.phone },
    { id: 2, spanSize: 'col-span-1', label: "E-mail", value: partner.email },
    { id: 3, spanSize: 'col-span-1', label: "Nome do contato operacional", value: partner.operationalContact.name },
    { id: 10, spanSize: 'col-span-1', label: "WhatsApp operacional", value: partner.operationalContact.phone },
    { id: 11, spanSize: 'col-span-1', label: "Tipo de empresa", value: formatCompanyType(partner.companyType) },
    { id: 12, spanSize: 'col-span-1', label: "Tipo de parceiro", value: formatPartnerType(partner.partnersType) },
    { id: 13, spanSize: 'col-span-1', label: "Faturamento mensal", value: maskCurrency(partner.incomeValue) },
  ]
}
export function partnerAddressInfo(partner) {
  return [
    { id: 1, spanSize: 'col-span-1', label: "CEP", value: partner.address?.zipcode },
    { id: 2, spanSize: 'col-span-2', label: "Endereço", value: partner.address?.street },
    { id: 3, spanSize: 'col-span-1', label: "Número", value: partner.address?.number },
    { id: 4, spanSize: 'col-span-2', label: "Complemento", value: partner.address?.complement },
    { id: 5, spanSize: 'col-span-1', label: "Estado", value: partner.address?.state },
    { id: 6, spanSize: 'col-span-1', label: "Cidade", value: partner.address?.city },
    { id: 7, spanSize: 'col-span-1', label: "Bairro", value: partner.address?.district },
  ]
}